import React, { useState } from 'react'
import { Form, Input, InputNumber, Modal, Select } from 'antd'
import strings from '../../../../../strings'

const FormItem = Form.Item;
const Option = Select.Option;
const TransferItem = ({
    open,
    onCancel,
    user,
    allProducts
}) => {
    const [form] = Form.useForm();
    const [ loading, setLoading ] = useState(false);

    const handleAddTransfer = () => {}
  return (
    <Modal
        open={open}
        onCancel={onCancel}
        title={strings.transferItem}
        okText="Transfer Item"
        confirmLoading={loading}
        onOk={handleAddTransfer}
    >
        <Form form={form} layout="vertical">
            <FormItem name="product" label={strings.product}>
                <Select>
                    {allProducts && allProducts.map((prod, index) => {
                        return (<Select.Option value={prod.id} key={index}>{prod.name}</Select.Option>)
                    })}
                </Select>
            </FormItem>

            <FormItem name="quantity" label={strings.quantity}>
                <InputNumber min={0} style={{width: "100%"}} />
            </FormItem>

            <FormItem name="status" label={strings.status}>
                <Select>
                    <Select.Option value={"Receiving"}>Receiving</Select.Option>
                    <Select.Option value={"Transferring"}>Transferring</Select.Option>
                </Select>
            </FormItem>

            <FormItem label={strings.stockUnit}>               
                <Select size="large" showSearch  optionFilterProp="children">
                <Option value="bag">{strings.bag}</Option>
                <Option value="bottles">{strings.bottle}</Option>
                <Option value="bunch">{strings.bunch}</Option>
                <Option value="can">{strings.can}</Option>
                <Option value="carton">{strings.carton}</Option>
                <Option value="crate">{strings.crate}</Option>
                <Option value="cup">{strings.cup}</Option>
                <Option value="dozen">{strings.dozen}</Option>
                <Option value="gigabyte">{strings.gigabytes}</Option>
                <Option value="gram">{strings.gram}</Option>
                <Option value="kg">{strings.kilogram}</Option>
                <Option value="litre">{strings.litre}</Option>
                <Option value="pack">{strings.pack}</Option>
                <Option value="pair">{strings.pair}</Option>
                <Option value="pcs">{strings.pieces}</Option>
                <Option value="plate">{strings.plate}</Option>
                <Option value="tonne">{strings.tonne}</Option>
                <Option value="unit">{strings.uNIT}</Option>
                <Option value="yard">{strings.yard}</Option>
                <Option value="satchet">{strings.satchet}</Option>
                <Option value="tablet">{strings.tablet}</Option>
                </Select>
            </FormItem>

            <FormItem name="receiver" label={strings.receiver}>
                <Input style={{width: "100%"}} />
            </FormItem>
        </Form>
    </Modal>
  )
}

export default TransferItem